export default {
    filterAliases: {
        id: 'id',
        topics: 'topics.name',
        departments: 'department.name',
        researchers: 'researchers.name',
        strands: 'strand.name',
        date: 'date',
        fundingAgency: 'fundingAgency.name',
        startDateString: 'startDateString',
        endDateString: 'endDateString',
        year: 'year',
        endYear: 'endYear',
        projects: 'projects.name',
        webshopArtcode: 'webshopArtcode',
        bookType: 'bookType',
        seriesTitle: 'seriesTitle',
    },
    filterTitles: {
        topics: 'topics',
    },
    filters: {
        alphabet: 'abcdefghijklmnopqrstuvwxyz',
    },
    operators: {
        in: 'In',
        lowerThan: 'Lt',
        greaterThan: 'Gt',
        notIn: 'NotIn',
    },
    keys: {
        id: 'id',
        startDate: 'startDate',
        endDate: 'endDate',
        year: 'yearInt',
        endYear: 'endYearInt',
        isForMedia: 'isForMedia',
        isEducation: 'isEducation',
    },
    values: {
        maxYear: '9999',
        series: 'Series',
    },
    inputTypes: {
        select: 'select',
        singleSelect: 'singleSelect',
        date: 'date',
        yearRange: 'yearRange',
        none: 'none',
        buttons: 'buttons',
    },
    queryParams: {
        page: 'page',
        date: 'date',
        text: 'text',
        letters: 'letters',
        year: 'year',
    },
    paths: {
        base: '/api',
        news: '/news',
        events: '/event',
        profiles: '/profiles',
        publications: '/publications',
        projects: '/projects',
        books: '/books',
    },
}
